module.exports = __webpack_public_path__ + "img/ETH.ed7f5f00.svg";